//
//
//
//
//
//

export default {
    async mounted() {
        await Promise.all([
            this.$store.dispatch('apidata/loadResortData'),
            this.$store.dispatch('checkWebP'),
        ]);

        if (!this.$store.state.apidata.resortDataError) {
            this.$store.commit('apidata/setIsDataReady', true);
        } else {
            this.$store.commit('setFatalError', this.$t('errors.loading'));
            this.$bugsnag.notify(new Error(`Iframe view: Error loading resort data: ${this.$store.state.apidata.resortDataError}`));
        }
    },
};
